<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Plan Elements
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-list
          bordered
          separator
        >
          <q-item
            v-for="planElement in planElements.data"
            :key="planElement.id"

            :class="{ 'bg-grey-3': bookingWeek.hasPlanElementTemplate(planElement) }"
            clickable
            @click="bookingWeek.addPlanElementTemplate(planElement)"
          >
            <q-item-section style="pointer-events: none;">
              <q-checkbox
                :model-value="bookingWeek.hasPlanElementTemplate(planElement)"
                :disabled="bookingWeek.hasPlanElementTemplate(planElement)"
                :label="planElement.name"
              />
            </q-item-section>
          </q-item>
          <q-item
            clickable
            @click="bookingWeek.addCustomPlanElement()"
          >
            <q-item-section avatar>
              Custom
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import BookingWeek from 'src/models/schedule/BookingWeek'

export default {
  name: 'SelectPlanElementsDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    bookingWeek: {
      type: BookingWeek,
      required: true
    }
  },
  models: {
    planElements: {
      showingBadges: 'default'
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  computed: {
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
